module.exports = __webpack_public_path__ + "img/thepwatana-warning.e8a6cdce.png";